{
  "de": {
    "folders": {
      "breadcrumb": {
        "contentCount": "{count} Inhalt | {count} Inhalte",
        "overview": "Übersicht",
        "showPath": "Ordnerpfad anzeigen",
        "up": "Eine Ebene nach oben"
      },
      "buttons": {
        "back": "Zurück",
        "clearDiscarded": "Papierkorb leeren",
        "createFolder": "Ordner anlegen",
        "deleteFolder": "In Papierkorb verschieben",
        "moveFolder": "Ordner verschieben",
        "renameFolder": "Ordner umbenennen",
        "renameItem": "Umbenennen"
      },
      "emptyTrashDialog": {
        "button": "Leeren",
        "text": "Diese Aktion kann nicht mehr rückgängig gemacht werden. Alle Inhalte im Papierkorb werden dauerhaft gelöscht.",
        "title": "Papierkorb endgültig leeren?"
      },
      "confirmDeleteDialog": {
        "button": "Ja, löschen",
        "text": "Gelöschte Inhalte lassen sich nicht wieder herstellen.",
        "title": "Inhalte endgültig löschen"
      },
      "discarded": {
        "alert": {
          "text": "Vom Arbeitsblatt bis zur Audio-Aufnahme - wenn du Materialien löschst, landen sie hier im Papierkorb und werden <strong>nach 30 Tagen</strong> endgültig entfernt."
        },
        "hints": {
          "noItems": {
            "emptyTable": "Es gibt aktuell keine Inhalte in deinem Papierkorb."
          }
        },
        "subline": "Gelöschte Materialien und Ordner bleiben <strong>30 Tage</strong> im Papierkorb. Bis dahin kannst du sie wiederherstellen, danach werden sie endgültig entfernt."
      },
      "headings": {
        "discarded": "Papierkorb",
        "search": "Deine Ablage durchsuchen",
        "searchResults": "{count} Suchergebnisse"
      },
      "hints": {
        "emptySubfolder": {
          "emptyTable": "Es gibt aktuell keine Inhalte in diesem Ordner.",
          "text": "Du kannst einfach Inhalte aus anderen Ordnern in diesen Ordner verschieben oder neue Inhalte und Unterordner direkt hier anlegen.",
          "title": "Dieser Ordner ist leer"
        },
        "noItems": {
          "addContent": "Neuen Inhalt anlegen",
          "emptyTable": "Bisher sind noch keine Inhalte in deiner Ablage.",
          "text": "Organisiere alle Inhalte und Materialien, die du erstellt hast, in Ordnern und finde sie einfach wieder.",
          "title": "Deine Ablage",
          "videoId": "1154655532",
          "videoTitle": "Tutorial: Deine Inhalte organisieren"
        },
        "share": {
          "text": "Teile und nutze Material mit Kolleg*innen. Per Remix können sie es kopieren, anpassen und verwenden.",
          "title": "Sharing is caring: Material gemeinsam nutzen"
        }
      },
      "labels": {
        "foldersNew": "Ordner anlegen"
      },
      "bulk": {
        "actionsDropdown": "Inhalte ...",
        "clearSelection": "Auswahl aufheben",
        "modals": {
          "delete": {
            "description": "Die ausgewählten Inhalte werden in den Papierkorb verschoben. Du kannst Inhalte innerhalb von 30 Tagen aus dem Papierkorb wiederherstellen.",
            "heading": "In den Papierkorb verschieben",
            "singleItemDescription": "Innerhalb von 30 Tagen kannst du Inhalte aus deinem Papierkorb wieder herstellen.",
            "submit": "Ja, in den Papierkorb"
          },
          "move": {
            "heading": "Inhalte verschieben"
          }
        },
        "moveToFolder": "In Ordner verschieben",
        "selectedItems": "{count} Inhalt ausgewählt | {count} Inhalte ausgewählt",
        "undiscardItems": "Wiederherstellen"
      },
      "filter": {
        "customRange": "Zeitraum festlegen",
        "dateFrom": "Von",
        "dateTo": "Bis",
        "duration": "Zeitraum",
        "items": "Material und Ordner",
        "last30Days": "Letzten 30 Tage",
        "last7Days": "Letzten 7 Tage",
        "lastYear": "Letztes Jahr ({ year })",
        "thisYear": "Dieses Jahr ({ year })",
        "totalPeriod": "Gesamter Zeitraum"
      },
      "links": {
        "trash": "Papierkorb ansehen"
      },
      "modals": {
        "createFolder": {
          "heading": "Ordner anlegen"
        },
        "moveFolder": {
          "folder": "Ordner",
          "moveToNewFolder": "In neuen Ordner verschieben",
          "newFolder": "Neuer Ordner"
        },
        "renameFolder": {
          "heading": "Ordner umbenennen"
        }
      },
      "navbarTitle": "Meine Ablage",
      "search": {
        "placeholder": "Meine Ablage durchsuchen..."
      },
      "subtitle": "Meine Ablage",
      "title": "Meine Ablage"
    }
  }
}
